export default __webpack_public_path__ + "static/shb-23b5c9283947c389cd499617d1889b80.png";